module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscription-plan bg-white"
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center tab-group"
  }, _vm._l((_vm.tabList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-text width-50 cursor-pointer text-center",
      class: {
        'active-tab': item.id == _vm.tab
      },
      on: {
        "click": function($event) {
          _vm.setTab(item.id)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.title) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    class: _vm.$vuetify.breakpoint.width > 650 ? '' : 'px-8'
  }, [(_vm.tab == 'yearly') ? _c('package-card', {
    attrs: {
      "title": _vm.title,
      "subtitle": _vm.subtitle,
      "price": _vm.monthlyPrice,
      "option-list": _vm.optionList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab == 'monthly') ? _c('package-card', {
    attrs: {
      "title": _vm.title,
      "subtitle": _vm.subtitle,
      "price": _vm.annualPrice,
      "option-list": _vm.optionList
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30a313a3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/components/subscription_plan.vue
// module id = 1671
// module chunks = 180